<template>
  <div class="prod-log">
    <component v-if="isShowDetail" :is="componentId" :operationLogId="operationLogId" :id="queryId" :isBatchPrice="isBatchPrice" v-bind="rowData"></component>
    <Index v-show="!isShowDetail" />
  </div>
</template>

<script>
import Index from '@components/prod/log/index.vue';
import LogDetail from '@components/prod/log/logDetail';
import AddLogDetail from '@components/prod/log/addLogDetail';
import DelLogDetail from '@components/prod/log/delLogDetail';
import UpdateLogDetail from '@components/prod/log/updateLogDetail';
import ShopLogDetail from '@components/prod/log/shopLogDetail';
import PutGoodsDetail from '@components/prod/log/putGoodsDetail';
import ProdModifyDetail from '@components/prod/log/prodModifyDetail';
import { mapActions, mapGetters, mapMutations } from 'vuex';

// 商品铺货日志 商品新增日志 商品删除日志 更新店铺商品日志 小店商品操作日志 货源提报日志
const detailComponentMap = {
  onShelvesLog: LogDetail,
  onShelvesLogNew: LogDetail,
  newProductLog: AddLogDetail,
  delProductLog: DelLogDetail,
  updateToShopLog: UpdateLogDetail,
  shopOperationLog: ShopLogDetail,
  shopOperationLog: ShopLogDetail,
  putGoodsLog: PutGoodsDetail,
  publishStoresLog: LogDetail,
  prodModify: ProdModifyDetail,
};

export default {
  components: {
    Index,
  },
  data() {
    return {
      isBatchPrice: false,
      componentId: '',
      queryId: '',
      rowData:{},
      operationLogId:'',
    };
  },
  computed: {
    // 当前所处tab页
    ...mapGetters(['getLogActiveName']),
    isShowDetail(){
      return !!this.queryId || !!this.operationLogId
    }
  },
  watch: {
    $route: {
      handler(val) {
        // 路由变化的时候清空一下id，解决下次进来组件被缓存无法重新获取详情问题
        this.queryId = ''
        this.operationLogId = ''
        if (!['s_prod_log', 'd_prod_log'].includes(val.name)) return;
        let activeName = this.getLogActiveName;
        const queryId = val.query.id;
        const operationLogId = val.query.operationLogId;
        const puhuoDialog = val.query.puhuoDialog;
        if(activeName === 'prodModify'){// 商品修改
          this.rowData = {
            startTime:val.query.startTime,
            operateSubType:val.query.operateSubType,
          }
        }
        if (this.$fromGyl && puhuoDialog == '5') {
          //货源池新增商品进入  
          activeName = 'newProductLog'
          this.setActiveName('newProductLog');
        }
        if (activeName) {
          this.componentId = detailComponentMap[activeName];
        }
        if(operationLogId){
          this.operationLogId = operationLogId;
        }else{
          this.operationLogId = ''
        }
        if (queryId) {
          this.queryId = queryId;
          this.isBatchPrice = val.query.isBatchPrice || false;
        } else {
          this.queryId = '';
          this.isBatchPrice = false;
        }
      },
      deep: true,
      immediate: true,
    },
    $fromGyl: {
        handler(val, oldVal) {
            if (val && this.$gylLogType == '2') {
                this.setActiveName('newProductLog');
            }
        },
        deep: true,
    },
  },
  methods: {
    ...mapActions(['initShops']),
    ...mapMutations(['setActiveName']),
  },
  created() {
    this.initShops();
  },
  beforeDestroy() {
    this.setActiveName('onShelvesLog');
  },
};
</script>

<style lang="scss" scoped>
.prod-log {
  padding: 16px 16px 0 16px;
}
</style>
